var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffd600",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 28.75c-2.3496-1.9788-2.4996-8.49 1.2-10 1.9632-0.8013 2.5992 3.6712 6.45 2.5525 0.7452-0.2163 2.4996 0.885 1.8612 2.565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.1529 5.9834c0.7572 0.5825 1.3488 1.3388 1.9068 2.3112 0.486 0.84875 1.5672 3.2124 0.5772 4.5474-1.1208 1.5075-4.3644 2.0163-4.3644 3.4075 0 1.0463 1.422 2.2413 2.1816 3.4088 1.1424 1.7563 0.6228 3.4588 0 4.545-0.3228 0.5638-0.8724 1.0137-1.4436 1.3712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.76 13.75c0.1572 0.8075 0.24 1.6437 0.24 2.5 0 6.9037-5.3724 12.5-12 12.5s-12-5.5963-12-12.5c0-6.9038 5.3724-12.5 12-12.5 0.5928 0 1.176 0.045 1.746 0.13125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.8 6.25c0 3.0862-4.8 7.5-4.8 7.5s-4.8-4.4138-4.8-7.5c0-3.1638 2.4804-5 4.8-5s4.8 1.8362 4.8 5z",
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.0f4a52b15c400250e0b2730217ceb59c.svg";
export { ForwardRef as ReactComponent };